import { t } from '../../i18n/i18n';

const setVisible = (visibleFilter) =>
  visibleFilter.map((filter) => ({
    ...filter,
    ...{ name: t(filter?.name) },
  }));

export default setVisible;
